import React, {Component} from 'react';
import dotAccess from 'dot-access';
import {InvertedButtonLink} from '../components/output/ButtonLink';
import {InvertedButton, SubmitButton} from '../components/output/Button';
import RemoteInputSelect from '../components/input/RemoteInputSelect';
import InputSelect from '../components/input/InputSelect';
import InputTextAutocomplete from '../components/input/InputTextAutocomplete';
import InputText from '../components/input/InputText';
import {HorizontalInput, VerticalInput} from '../components/container/LayoutRow';
import {BoxEdit} from '../components/container/Box';
import './AdvancedSearch.css';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import {R_PHRASES_AND_SCORE_P_VISIBLE, ShowBasedOnConfig} from "../components/container/ShowBasedOnConfig";

class AdvancedSearch extends Component {
  constructor(props, context) {
    super(props, context);

    const { filters } = props.location.state;
    filters.fullSearch = '';
    this.state = { resource: { ...filters } };
  }

  handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    let updated = { ...this.state.resource };
    dotAccess.set(updated, name, value);

    this.setState({ resource: updated });
  };

  clearForm = () => {
    this.setState({ resource: {} });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { history } = this.props;

    history.push({
      pathname: '/substances/management',
      state: this.state.resource,
    });
  };

  renderSearchForm = () => {
    const { resource } = this.state;
    return (
      <HorizontalInput value={resource} handleChange={this.handleChange} style={{ alignItems: 'flex-start' }}>
        <VerticalInput style={{ flex: 1 }}>
          <RemoteInputSelect from="agents" optionValueName="description" optionLabelName="description" name="agentDescription" label="advancedSearch.agent" />
          <InputTextAutocomplete from='substances/physical-state-suggestions' name="substancePhysicalState" label="advancedSearch.physicalState" style={{ width: 300 }} />
          <InputText name="substanceSupplier" label="advancedSearch.supplier" style={{ width: 300 }} />
          <HorizontalInput>
            <InputText name="agentCasRn" label="advancedSearch.casRn" style={{ flex: 1 }} />
            <InputText name="substanceCode" label="advancedSearch.code" style={{ flex: 1 }} />
            <InputText name="substanceSds" label="advancedSearch.sds" style={{ flex: 1 }} />
          </HorizontalInput>
          <HorizontalInput>
            <InputSelect name="enabled" label="advancedSearch.state" options={[{ value: 'true', label: 'advancedSearch.enabled' }, { value: 'false', label: 'advancedSearch.disabled' }]} />
            <InputSelect name="toBeEvaluated" label="advancedSearch.toBeEvaluated" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} style={{ marginLeft: '5px' }} />
          </HorizontalInput>
          <ShowBasedOnConfig configKey={R_PHRASES_AND_SCORE_P_VISIBLE}>
              <BoxEdit label="advancedSearch.rPhrases.name">
                <HorizontalInput>
                  <InputSelect name="rCutRisk" label="advancedSearch.rPhrases.cutaneousRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
                  <InputSelect name="rCancerRisk" label="advancedSearch.rPhrases.cancerousRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
                </HorizontalInput>
                <HorizontalInput  style={{ marginTop: 10 }}>
                  <InputSelect name="rMutagenRisk" label="advancedSearch.rPhrases.mutagenRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
                  <InputSelect name="rInhalRisk" label="advancedSearch.rPhrases.inhalationRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
                </HorizontalInput>
                <InputText name="rCode" label="advancedSearch.rPhrases.code" style={{ flex: 1, margin: '10px 5px' }} />
              </BoxEdit>
          </ShowBasedOnConfig>
          <BoxEdit label="advancedSearch.hPhrases.name" style={{ marginTop: 10 }}>
            <HorizontalInput>
              <InputSelect name="hCutRisk" label="advancedSearch.hPhrases.cutaneousRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
              <InputSelect name="hCancerRisk" label="advancedSearch.hPhrases.cancerousRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
            </HorizontalInput>
            <HorizontalInput style={{ marginTop: 10 }}>
              <InputSelect name="hMutagenRisk" label="advancedSearch.hPhrases.mutagenRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
              <InputSelect name="hInhalRisk" label="advancedSearch.hPhrases.inhalationRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
            </HorizontalInput>
            <HorizontalInput style={{ marginTop: 10 }}>
              <InputSelect name="hTeratogenRisk" label="advancedSearch.hPhrases.teratogenRisk" options={[{ value: 'true', label: 'advancedSearch.true' }, { value: 'false', label: 'advancedSearch.false' }]} />
            </HorizontalInput>
            <InputText name="hCode" label="advancedSearch.hPhrases.code" style={{ flex: 1, margin: '10px 5px' }} />
          </BoxEdit>
        </VerticalInput>
        <VerticalInput style={{ flex: 1 }}>
          <InputText name="departmentArea" label="advancedSearch.area" />
          <InputText name="departmentName" label="advancedSearch.department" />
          <InputText name="activity" label="advancedSearch.activity" />
          <InputText name="exposureTime" label="advancedSearch.exposition" />
          <InputText name="contactFrequency" label="advancedSearch.frequency" />

              <InputSelect name="revelationProcessTemperaturePre" label="advancedSearch.revelationProcessTemperaturePre"
            	  options={[{ value: 'PROCESS_TEMPERATURE_LESS', label: 'substancesManagement.revelationProcessTemperatureValuesPre.PROCESS_TEMPERATURE_LESS' },
            		  { value: 'PROCESS_TEMPERATURE_MED', label: 'substancesManagement.revelationProcessTemperatureValuesPre.PROCESS_TEMPERATURE_MED' },
            		  { value: 'PROCESS_TEMPERATURE_MAX', label: 'substancesManagement.revelationProcessTemperatureValuesPre.PROCESS_TEMPERATURE_MAX' }]} />

             <InputText name="revelationHandlingTimeMinutesPre" label="advancedSearch.revelationHandlingTimeMinutesPre" />
             <InputText name="revelationFrequencyOfUseDaysPre" label="advancedSearch.revelationFrequencyOfUseDaysPre" />


            <BoxEdit label="advancedSearch.dailyQuantity.name">
            <BoxEdit label="advancedSearch.dailyQuantity.max">
              <HorizontalInput>
                <InputText
                  name="maxDailyQuantity.value"
                  label="substancesManagement.quantity"
                  style={{ flex: '0.5 1 auto', marginRight: '10px' }}
                />
                <InputTextAutocomplete
                  from={'departmentActivitySubstances/units'}
                  name="maxDailyQuantity.unit"
                  label="substancesManagement.unit"
                  style={{ flex: '2 1 auto' }}
                />
              </HorizontalInput>
            </BoxEdit>
            <BoxEdit label="advancedSearch.dailyQuantity.min">
              <HorizontalInput>
                <InputText
                  name="minDailyQuantity.value"
                  label="substancesManagement.quantity"
                  style={{ flex: '0.5 1 auto', marginRight: '10px' }}
                />
                <InputTextAutocomplete
                  from={'departmentActivitySubstances/units'}
                  name="minDailyQuantity.unit"
                  label="substancesManagement.unit"
                  style={{ flex: '2 1 auto' }}
                />
              </HorizontalInput>
            </BoxEdit>
          </BoxEdit>
          <BoxEdit label="advancedSearch.presentQuantity.name" style={{ marginTop: 10 }}>
            <BoxEdit label="advancedSearch.presentQuantity.max">
              <HorizontalInput>
                <InputText
                  name="maxActualQuantity.value"
                  label="substancesManagement.quantity"
                  style={{ flex: '0.5 1 auto', marginRight: '10px' }}
                />
                <InputTextAutocomplete
                  from={'departmentActivitySubstances/units'}
                  name="maxActualQuantity.unit"
                  label="substancesManagement.unit"
                  style={{ flex: '2 1 auto' }}
                />
              </HorizontalInput>
            </BoxEdit>
          </BoxEdit>
        </VerticalInput>
      </HorizontalInput>
    );
  };

  render() {

    return (
      <div className="AdvancedSearch">
        <h2>{getLabel(this.context.locale, 'advancedSearch.title')}</h2>

        <form onSubmit={this.handleSubmit}>
          {this.renderSearchForm()}
          <SubmitButton label="general.search" />
          <InvertedButton onClick={this.clearForm} style={{ marginLeft: '10px' }}>{getLabel(this.context.locale, 'general.clear')}</InvertedButton>
          <InvertedButtonLink
              to={'/substances/management'}
              label="general.cancel"
              style={{ marginLeft: '10px' }}
          />
        </form>
      </div>
    );
  }

}

AdvancedSearch.contextTypes = {
  locale: PropTypes.string,
};

export default AdvancedSearch;



// WEBPACK FOOTER //
// ./src/main/pages/AdvancedSearch.js